<script>
    import _                         from 'lodash'
    import { onMount, onDestroy }    from 'svelte'
    import loader                    from '@beyonk/async-script-loader'
    import { createEventDispatcher } from 'svelte'
    import { frontend }              from './api.js'
    
    /*
    * See 
    * - https://github.com/beyonk-adventures/svelte-social-auth/blob/master/src/google-auth/GoogleAuth.svelte
    * - https://anmagpie.medium.com/login-with-google-code-to-access-token-any-client-to-any-server-cc0a9074d07f
    */

    let auth

    const dispatch  = createEventDispatcher()
    const clientId  = "367341740652-jc2hv51gus0ortp0m2ob25eda83ibaji.apps.googleusercontent.com" /* used for dev */
    const url       = '//apis.google.com/js/api:client.js'

    const scope = _.join([
        'profile',
        'email',
        'https://www.googleapis.com/auth/drive.metadata',
        'https://www.googleapis.com/auth/drive.readonly',
        'https://www.googleapis.com/auth/spreadsheets.readonly'
    ], ' ')

    onMount(() => {
        loader([{ type: 'script', url }], test, init)
    })

    onDestroy(() => {
        auth = null
    })

    function test() {
        return window['gapi']
    }

    function init () {
        gapi.load('auth2', async () => {
            auth = gapi.auth2.init({ client_id: clientId, ux_mode: 'popup', scope })
        })
    }
    
    function grab() {
        auth.grantOfflineAccess({ scope }).then(token => {
            dispatch('access-granted', {
                token,
                redirectUri: frontend,
            })
        })
    }
</script>

<button class="ui blue button" on:click={grab}>
    <i class="google icon"></i>
    Login no Google
</button>
